<!--<div>-->
    <ng-container *ngFor="let form of forms.controls; let i = index">
        <div class="flex items-center gap-4 flex-wrap">
            <ng-container [ngTemplateOutlet]="formTemplate" [ngTemplateOutletContext]="{form}"></ng-container>
            <button app-round-button class="m-4" Color="red" (click)="forms.removeAt(i)"><fa-icon icon="trash"></fa-icon></button>
        </div>
        <mat-divider></mat-divider>
    </ng-container>
    <div class="flex items-center gap-4 flex-wrap">
        <ng-container [ngTemplateOutlet]="formTemplate" [ngTemplateOutletContext]="{ form: pendingForm }"></ng-container>
        <button app-round-button [Disabled]="pendingForm.invalid" class="m-4" (click)="pushPendingForm()"><fa-icon icon="plus"></fa-icon></button>
    </div>
<!--</div>-->
<ng-template #formTemplate let-form="form">
    <!--    <form [formGroup]="form" class="flex gap-4 flex-wrap">-->
<!--    <div class="flex gap-4 flex-wrap grow">-->
        <mat-form-field style="flex-basis: 30rem">
            <mat-label>Name</mat-label>
            <input matInput type="text" [formControl]="form.controls.name" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Menge</mat-label>
            <input matInput type="number" [formControl]="form.controls.quantity" />
        </mat-form-field>
        <mat-form-field floatLabel="never">
            <mat-label>Einheit</mat-label>
            <mat-select [formControl]="form.controls.quantityTypeId">
                <mat-option *ngFor="let t of quantityTypes$ | async" [value]="t.Id">{{ t.Name }}</mat-option>
            </mat-select>
        </mat-form-field>
<!--    </div>-->
    <!--    </form>-->
</ng-template>
